import { render, staticRenderFns } from "./DebitNote.vue?vue&type=template&id=6236fced&scoped=true"
import script from "./DebitNote.vue?vue&type=script&lang=js"
export * from "./DebitNote.vue?vue&type=script&lang=js"
import style0 from "./DebitNote.vue?vue&type=style&index=0&id=6236fced&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6236fced",
  null
  
)

export default component.exports